import {HttpServiceBase} from '../../../core/services/http-service-base';
import {INewsletterListResponse} from '../interfaces/newsletter-list-response';
import {INewsletter} from '../interfaces/newsletter.interface';

export abstract class INewsHttpService extends HttpServiceBase{
    abstract getList(userId: number): Promise<INewsletterListResponse>;
    abstract get(userId: number, newsletterId: number): Promise<INewsletter | null>;
}
